module.exports = __webpack_public_path__ + "static/img/83.1d75a32d.png";